export function getPriorityBackgroundColor(value) {
  switch (value) {
    case 'Low':
      return '#e4e7eb'
    case 'Medium':
      return '#d1eefc'
    case 'High':
      return '#facdcd'
    case 'Urgent':
      return '#FCEFC7'
    default:
      return '#e4e7eb' // fallback color (white), change if needed
  }
}

export function getPriorityTextColor(value) {
  switch (value) {
    case 'Low':
      return '#616e7c'
    case 'Medium':
      return '#166086'
    case 'High':
      return '#7C5E10'
    case 'Urgent':
      return '#780a0a'
    default:
      return '#616e7c'
  }
}
